<template>
  <div class="q-ml-md">
    <div class="row">
      <div class="row col-12">
        <div>
          <p
            class="row col-12 items-center justify-between text-h6 text-weight-bold text-brand-5 items-center texto-titulo"
          >
            Relatório de Cátalogo Simplificado
            <Modal
              @unidade="getCatalogoSimplificado"
              :tipoSelecao="'ferramentaria'"
              :desativarDataEntrada="true"
              :desativarDataSaida="true"
              :desativarDocumentoEntrada="true"
              :desativarDocumentoSaida="true"
              :desativarOrigem="true"
              :desativarDevolucao="true"
              :desativarRetirada="true"
              :desativarCentro="true"
              :desativarSolicitante="true"
              :desativarStatus="true"
              :loadingValue="loadingValue"
              :dataDisable="true"
              :desativarFornecedor="true"
              :desativarNumero="true"
              :desativarPatrimonio="true"
              :desativarFornecedorSelect="true"
              :desativarTempo="true"
              :desativarTipoMovimento="true"
              :desativarNtransferencia="true"
              :classUnidade="'col-6'"
              :classCodigo="'col-5'"
              :classDescricao="'col-6'"
              :classGrupo="'col-5'"
              :classSubgrupo="'col-6'"
              :classOrigem="'col-5'"
            />
          </p>
        </div>
      </div>
    </div>
    <flexmonster
      :exibir="exibir"
      :link="link"
      :columns="slice"
      :slice="slice"
      :types="types"
      :grid="layout"
      :updateLink="updateLink"
      :showTotals="showTotals"
      :showGrandTotals="showGrandTotals"
      :exportName="'Cátalogo_Simplificado'"
      :filtros="filtros"
      :gerarCsv="gerarCsv"
      :url="url"
      :urlEp="urlEp"
      :formats="formats"
      :dadosRelatorioSalvo="dados"
      :salvarType="'ferramentaria-relatorio-catalogo-simplificado'"
      @flexmonsterLoading="loadingStop"
      @enviarRespostaEp="getRelatorioSalvo"
    />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import Flexmonster from "../../relatorios/components/Flexmonster.vue";
import Modal from "../components/ModalFerramentaria.vue";

export default {
  components: { Flexmonster, Modal },
  setup() {
    const store = useStore();
    const route = useRoute();

    const slice = ref({
      columns: [
        { uniqueName: "Codigo" },
        { uniqueName: "Descricao" },
        { uniqueName: "Unidade Medida" },
        { uniqueName: "Nome Grupo" },
        { uniqueName: "Nome Subgrupo" },
        { uniqueName: "Quantidade Ativos" },
      ],
      rows: [
        { uniqueName: "Codigo" },
        { uniqueName: "Descricao" },
        { uniqueName: "Unidade Medida" },
        { uniqueName: "Nome Grupo" },
        { uniqueName: "Nome Subgrupo" },
        { uniqueName: "Quantidade Ativos" },
      ],
      reportFilters: "",
      measures: "",
    });
    const link = ref("");
    const id = route.params.id;
    const layout = ref("flat");
    const loadingValue = ref("");
    const types = ref({
      Codigo: {
        type: "string",
      },
    });
    const updateLink = ref(0);
    const exibir = ref(false);
    const filtros = ref("");
    const showTotals = ref("");
    const formats = ref([
      {
        name: "",
        thousandsSeparator: "",
      },
    ]);
    const url = ref("");
    const gerarCsv = ref(false);
    const urlEp = ref("");
    const dados = ref({});
    const showGrandTotals = ref("");
    const relatorioLink = localStorage.getItem("relatorioLink");

    const getCatalogoSimplificado = async (data, value) => {
      try {
        let filtrosObject = {
          codigo: value.codigo,
          unidade: value?.unidade?.label,
          descricao: value.descricao,
          grupo: value.grupo?.nome,
          subgrupo: value.subGrupo?.nome,
        };

        loadingValue.value = true;
        const response = await store.dispatch(
          "ferramentaria/relatorioCatalogoSimplificado",
          {
            codigo: value.codigo,
            descricao: value.descricao,
            unidade: value.unidade.id,
            grupo: value.grupo.catalogoGrupoUuid,
            subgrupo: value.subGrupo.catalogoSubGrupoUuid,
          }
        );

        link.value = response.data.resultado.dados;
        updateLink.value++;
        loadingValue.value = false;
        filtros.value = JSON.stringify(filtrosObject);
        exibir.value = true;
        url.value = response?.request?.responseURL;
      } catch (error) {
        loadingValue.value = false;
        console.log(error);
      }
    };

    const verificarUrl = async () => {
      if (
        id != "carregado" &&
        id != undefined &&
        id != "" &&
        id != "carregadoLink"
      ) {
        try {
          const response = await store.dispatch("rel/listarRelatoriosSalvos", {
            id,
          });
          let value = response.data.resultado.dados.map((e) => {
            e.template = JSON.parse(e.template);
            return e;
          });
          dados.value = value[0];
          urlEp.value = dados.value.url;
          url.value = dados.value.url;
          gerarCsv.value = true;
        } catch (error) {
          console.log(error);
        }
        return;
      }
      if (id == "carregado" && store.state.rel.relatorioCarregado != null) {
        dados.value = store.state.rel.relatorioCarregado;
        console.log(dados.value);
        layout.value = dados.value.layout;
        showTotals.value = dados.value.showTotals;
        showGrandTotals.value = dados.value?.showGrandTotals;

        slice.value.columns = dados.value.columns;
        slice.value.rows = dados.value.rows;
        slice.value.reportFilters = dados.value.filtros;
        slice.value.measures = dados.value.values;

        slice.value?.rows.forEach((e) => {
          e.type = "number";
        });

        const response = await store.dispatch("rel/getCarregado", {
          url: dados.value.url.replace(
            /(?<=\/\/)[^.]+/,
            store.state.autenticacao.cliente[0]
          ),
        });

        link.value = response.data.return.url;
        updateLink.value++;
        loadingValue.value = false;
        url.value = response?.request?.responseURL;
        exibir.value = true;

        return;
      }

      if (
        id == "carregadoLink" &&
        relatorioLink != null &&
        relatorioLink != undefined
      ) {
        exibir.value = true;
        link.value = relatorioLink;
        updateLink.value++;
        url.value = relatorioLink;
        return;
      }
    };

    const getRelatorioSalvo = async (response) => {
      loadingValue.value = true;

      filtros.value = dados.value.filtros;
      layout.value = dados.value.template.layout;
      showTotals.value = dados.value.template.showTotals;
      showGrandTotals.value = dados.value.template?.showGrandTotals;
      link.value = response.resultado.dados;

      slice.value.columns = dados.value.template.columns;
      slice.value.rows = dados.value.template.rows;
      slice.value.reportFilters = dados.value.template.filtros;
      slice.value.measures = dados.value.template.values;
      exibir.value = true;

      slice.value?.rows.forEach((e) => {
        e.type = "number";
      });
      loadingValue.value = false;
    };

    const loadingStop = async (value) => {
      loadingValue.value = value;
    };

    onMounted(() => {
      verificarUrl();
    });

    return {
      getCatalogoSimplificado,
      slice,
      layout,
      types,
      link,
      updateLink,
      loadingValue,
      exibir,
      filtros,
      showTotals,
      id,
      getRelatorioSalvo,
      formats,
      loadingStop,
      verificarUrl,
      url,
      urlEp,
      gerarCsv,
      dados,
      showGrandTotals,
    };
  },
};
</script>
